import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/about";
import Header from "../components/Header";
import Vision_and_mission from "../pages/Vision_and_mission";
import Organization_chart from "../pages/Organization_chart";
import Rishikesh_plant from "../pages/Rishikesh_plant";
import Hyderabad_plant from "../pages/Hyderabad_plant";
import Gurgaon_plant from "../pages/Gurgaon_plant";
import Chennai_plant from "../pages/Chennai_plant";
import Bihar_muzaffarpur_plant from "../pages/Bihar_muzaffarpur_plant";
import Bhubaneswar_orissa_plant from "../pages/Bhubaneswar_orissa_plant";
import Corporate_office from "../pages/Corporate_office";
// import Gurgaon_plant_tenders from "../pages/Gurgaon_plant_tenders";
import Gurgaon_plant_tenders from "../pages/Gurgaon_plant_tenders";
import Rishikesh_plant_tenders from "../pages/Rishikesh_plant_tenders ";
import Chennai_plant_tenders from "../pages/Chennai_plant_tenders ";
import Odcl_plant_tenders from "../pages/Odcl_plant_tenders";
import Hyderabad_plant_tenders from "../pages/Hyderabad_plant_tenders ";
import Regional_sales_offices from "../pages/Regional_sales_offices";
import South_zone_office_hyderabad from "../pages/South_zone_office_hyderabad";
import East_zone_office_kolkata from "../pages/East_zone_office_kolkata";
import North_zone_office_gurgaon from "../pages/North_zone_office_gurgaon";
import West_zone_office_mumbai from "../pages/West_zone_office_mumbai";
import Lucknow_zone_office from "../pages/Lucknow_zone_office";
import Career from "../pages/Career";
import Contact_us from "../pages/Contact_us";
import Chennai_plant_archive from "../pages/Chennai_plant_archive";
import Essential_medicines from "../pages/Chennai_plant_archive";
import Branded_product_mix1 from "../pages/branded-product-mix1";
import Branded_product_mix from "../pages/branded_product_mix";
import Branded_product_mix2 from "../pages/branded-product-mix2";
import Chairman_desk from "../pages/chairman-desk";
import Gallery from "../pages/gallery";
import Gurgaon_plant_archive from "../pages/gurgaon_plant_archive";
import Hyderabad_plant_archive from "../pages/hyderabad_plant_archive";
import Idpl_news from "../pages/idpl-news";
import Important_links from "../pages/important-links";
import Inquiry from "../pages/inquiry";
import Odcl_plant_archive from "../pages/odcl_plant_archive";
import Otcproducts from "../pages/otcproducts";
import Example from "../pages/example";
import Pharma_formulations from "../pages/pharma-formulations";
import Purchase_procedure from "../pages/purchase-procedure";
import Quality_control from "../pages/quality-control";
import Research_and_development from "../pages/research_and_development";
import Rishikesh_plant_archive from "../pages/rishikesh_plant_archive";
import Shri_mansukh_mandaviya from "../pages/shri-mansukh-mandaviya";
import Tenders_archive from "../pages/tenders-archive";
import Corporate_office_tenders from "../pages/corporate_office_tenders";

export default function Router() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/vision&mission" element={<Vision_and_mission />} />
        <Route path="/organization-chart" element={<Organization_chart />} />
        <Route path="/rishikesh_plant" element={<Rishikesh_plant />} />
        <Route path="/hyderabad-plant" element={<Hyderabad_plant />} />
        <Route path="/gurgaon_plant" element={<Gurgaon_plant />} />
        <Route path="/chennai-plant" element={<Chennai_plant />} />
        <Route
          path="/bihar-muzaffarpur-plant"
          element={<Bihar_muzaffarpur_plant />}
        />
        <Route
          path="/bhubaneswar-orissa-plant"
          element={<Bhubaneswar_orissa_plant />}
        />
        <Route path="/corporate-office" element={<Corporate_office />} />
        <Route
          path="/gurgaon_plant_tenders"
          element={<Gurgaon_plant_tenders />}
        />
        <Route
          path="/rishikesh_plant_tenders"
          element={<Rishikesh_plant_tenders />}
        />
        <Route
          path="/chennai_plant_tenders"
          element={<Chennai_plant_tenders />}
        />
        <Route path="/odcl_plant_tenders" element={<Odcl_plant_tenders />} />
        <Route
          path="/hyderabad_plant_tenders"
          element={<Hyderabad_plant_tenders />}
        />
        <Route
          path="/regional-sales-offices"
          element={<Regional_sales_offices />}
        />
        <Route
          path="/south-zone-office-hyderabad"
          element={<South_zone_office_hyderabad />}
        />
        <Route
          path="/east-zone-office-kolkata"
          element={<East_zone_office_kolkata />}
        />
        <Route
          path="/north-zone-office-gurgaon"
          element={<North_zone_office_gurgaon />}
        />
        <Route
          path="/west-zone-office-mumbai"
          element={<West_zone_office_mumbai />}
        />
        <Route path="/Lucknow-zone-office" element={<Lucknow_zone_office />} />
        <Route path="/Career" element={<Career />} />
        <Route path="/Example" element={<Example />} />
        <Route path="/contact_us" element={<Contact_us />} />
        <Route
          path="/Chennai_plant_archive"
          element={<Chennai_plant_archive />}
        />
        <Route path="/essential_medicines" element={<Essential_medicines />} />
        <Route
          path="/branded_product_mix1"
          element={<Branded_product_mix1 />}
        />
        <Route path="/branded-product-mix" element={<Branded_product_mix />} />
        <Route
          path="/branded-product-mix2"
          element={<Branded_product_mix2 />}
        />
        <Route path="/chainman-desk" element={<Chairman_desk />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route
          path="/gurgaon_plant_archive"
          element={<Gurgaon_plant_archive />}
        />
        <Route
          path="/hyderabad_plant_archive"
          element={<Hyderabad_plant_archive />}
        />
        <Route path="/idpl-news" element={<Idpl_news />} />
        <Route path="/important-links" element={<Important_links />} />
        <Route path="/inquiry" element={<Inquiry />} />
        <Route path="/odcl_plant_archive" element={<Odcl_plant_archive />} />
        <Route path="/otcproducts" element={<Otcproducts />} />
        <Route path="/pharma-formulations" element={<Pharma_formulations />} />
        <Route path="/purchase-procedure" element={<Purchase_procedure />} />
        <Route path="/quality-control" element={<Quality_control />} />
        <Route
          path="/research&development"
          element={<Research_and_development />}
        />
        <Route
          path="/rishikesh_plant_archive"
          element={<Rishikesh_plant_archive />}
        />
        <Route
          path="/shri-mansukh-mandaviya"
          element={<Shri_mansukh_mandaviya />}
        />
        <Route path="/tenders-archive" element={<Tenders_archive />} />
        <Route
          path="/corporate_office_tenders"
          element={<Corporate_office_tenders />}
        />
      </Routes>
    </BrowserRouter>
  );
}
